import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { AuthGuard } from './AuthGuard'
import { useAuthz } from './useAuthz'

function AdminGate({ children }: { children: ReactNode }) {
  const { isWorkflowMember } = useAuthz()

  if (!isWorkflowMember) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-canvas">
        <div className="text-center">
          <p className="font-sans text-sm font-semibold text-fg">Access denied</p>
          <p className="mt-1 font-sans text-xs text-fg-secondary">
            You do not have permission to access this area.
          </p>
          <Link
            to="/wire"
            className="mt-6 inline-block rounded-full bg-solid px-5 py-2 text-xs font-bold uppercase tracking-widest text-white hover:bg-solid-hover transition-colors"
          >
            Go to WIRe home
          </Link>
          <p className="mt-4">
            <span className="font-sans text-xs text-fg-secondary cursor-default select-none">
              Need access?{' '}
            </span>
            <button
              type="button"
              className="font-sans text-xs text-fg-secondary underline hover:text-fg transition-colors"
            >
              Contact the WIRe team
            </button>
          </p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

/**
 * Wraps admin routes. Requires both a valid OIDC session (via AuthGuard) and
 * membership in at least one workflow role group (layout_and_design,
 * quality_control, editorial_manager, or post_production). Users who are
 * authenticated but lack a workflow role see a 403-style access denied page.
 */
export function AdminGuard({ children }: { children: ReactNode }) {
  return (
    <AuthGuard>
      <AdminGate>{children}</AdminGate>
    </AuthGuard>
  )
}
